import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import EssentialLayout from "@/components/menu-management/manage-essential/essential-layout";
import { Card } from "@/components/ui/card";
import { TabsList, Tabs, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import CetagoryTabs from "@/components/menu-management/manage-essential/essential-drinks/category/cetagory-tabs";
import AllergenTabs from "@/components/menu-management/manage-essential/essential-drinks/allergen/allergen-tabs";
import AddOnsTabs from "@/components/menu-management/manage-essential/essential-drinks/addons/addons-tabs";
import ModifiersTabs from "@/components/menu-management/manage-essential/essential-drinks/modifiers/modifiers-tabs";
import { useParams } from "react-router-dom";
import useAuth from "@/hooks/useAuth";
import { useFetchAllMenuData } from "@/hooks/use-fetch-all-menu-data";
import { useMemo, useState } from "react";
import EssentialSkeleton from "@/components/skeleton/essential-skeleton";

function EssentialStandardFoods() {
  const { id } = useParams();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState("cetagoris");

  const fetchOnly = useMemo(() => {
    switch (activeTab) {
      case "cetagoris":
        return ["categories"];
      case "add-ons":
        return ["addOns"];
      case "allergen":
        return ["allergens"];
      case "modifiers":
        return ["modifiers"];
      default:
        return ["categories"];
    }
  }, [activeTab]);

  const { groupLoading } = useFetchAllMenuData(user?.restaurant_id, id, {
    fetchOnly,
  });

  if (groupLoading) return <EssentialSkeleton />;
  return (
    <Layout2 LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}>
      <EssentialLayout>
        <Card className="bg-transparent col-span-1 md:col-span-2">
          <Tabs
            valueKey="essential-standard-foods"
            className="bg-transparent relative"
            defaultValue="cetagoris"
            onValueChange={setActiveTab}
          >
            <TabsList className="grid grid-cols-6 w-[700px]">
              <Separator className="absolute top-8" />
              <TabsTrigger className="bg-transparent" value="cetagoris">
                Categories
              </TabsTrigger>
              <TabsTrigger value="add-ons">Add-ons</TabsTrigger>
              <TabsTrigger value="allergen">Allergens</TabsTrigger>
              <TabsTrigger value="modifiers">Modifiers</TabsTrigger>
            </TabsList>
            <CetagoryTabs />
            <AddOnsTabs />
            <AllergenTabs />
            <ModifiersTabs />
          </Tabs>
        </Card>
      </EssentialLayout>
    </Layout2>
  );
}

export default EssentialStandardFoods;
